module.exports = __webpack_public_path__ + "static/img/simal_img5.ac5b91e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simal_img5.png
// module id = RKrF
// module chunks = 1